import { Spacing } from '@lichtblick/theme';
import styled from 'styled-components';
export const StyledBulletItem = styled.li`
  display: flex;
  &::before {
    content: '•';
    margin-right: ${Spacing.Xxs};
  }
`;

//# sourceMappingURL=ABulletItem.styles.js.map